import toastr from 'toastr'

export default {
	notify(type, message, { timeout = 5000, callback = null, title = '' } = {}) {
		toastr.options = {
			newestOnTop: false,
			progressBar: true,
			positionClass: 'toast-top-right',
			showDuration: 300,
			hideDuration: 500,
			timeOut: timeout,
			extendedTimeOut: 1000,
			showEasing: 'swing',
			hideEasing: 'linear',
			showMethod: 'fadeIn',
			hideMethod: 'fadeOut'
		};

		let toast = toastr[type](message, title);

		if (callback) callback(toast);

		return toast;
	},

	success(message, options = {}) {
		return this.notify('success', message, options);
	},

	error(message, options = {}) {
		return this.notify('error', message, options);
	},

	warning(message, options = {}) {
		return this.notify('warning', message, options);
	},

	info(message, options = {}) {
		return this.notify('info', message, options);
	},

	clear(toast = null) {
		toastr.clear(toast);
	}
}



// WEBPACK FOOTER //
// ./src/utils/notify.js